export const FULLFILL_AVAILABLE_CASE_TYPES = 'FULLFILL_AVAILABLE_CASE_TYPES'
